import { OpenCrCreationPayload } from './ducks';
import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';

export const api = {
  openCR: (url: string, payload: OpenCrCreationPayload): Promise<ExtendedAxiosResponse> => {
    return apiClient.get(`${url}`, {
      params: {
        crType: payload.crType,
        crSubType: payload.crSubType,
        ...payload.queryParams,
      },
    });
  },
};
